console.log('File called');

// filter popup js
$(document).on('click', '.filters_wrapper', function(e) {
	var thisf= $(this).parent().closest('.inner__container');
  if(thisf.hasClass('is-selected')){
    $(".inner__container").removeClass('is-selected');    
  }
  else{
    $(".inner__container").removeClass('is-selected');    
	thisf.addClass('is-selected');    
  }
});

// hide filter popup outside click
// $(document).on('click', function (event) {
//   if (!$(event.target).closest('.inner__container.is-selected').length) {
//     // ... clicked on the 'body', but not inside of #menutop
//     $(".inner__container").removeClass('is-selected');
//   }
// });

// filter close button js
$(document).on('click', '.filters_cross', function(e) {
	$(".inner__container").removeClass('is-selected');
	$(this).parent('.inner__container').removeClass('is-selected');

});

$(document).on('click', '.filters_wrapper_ul li.filter_name_li', function(e) {
	e.preventDefault();
	$("li.sort_options_custom").removeClass('active');
	var classexist = $(this).hasClass("active");
	console.log('clicked');
	if (classexist == true) {
		$(this).removeClass('active');
		$("span.clear_all_text").hide();
	}
	if (classexist == false) {
		$(this).parents('.inner__container').find('li.filter_name_li').removeClass('active');
		$(this).addClass('active');
	}
	var all_actives = $('li.filter_name_li.active').length;
	if (all_actives == 1) {
		var all_data_name = '';
		var cross_button = $(".cross_button_for_filters").html();
		var get_name = $("li.filter_name_li.active input.tag_name_hidden").attr('data-name');
		var get_tag = $("li.filter_name_li.active input.tag_name_hidden").val();
		console.log('get_tag==' + get_tag);
		var get_col = $("#get_current_url").attr('data-col-url');
		var url = get_col + "/" + get_tag;
		console.log('get_col==' + get_col);
		console.log('url==' + url);
		all_data_name += '<div class="cross_btn_wrapper" >' + get_name + '<span class="individual_cross" data-tag="' + get_tag + '">' + cross_button + '</span>' + '</div>';
		var get_name = all_data_name.slice(0, -1);
		console.log('all_data_name==' + all_data_name);
		console.log('get_name==' + get_name);
		console.log('===================================================================================================================================');
	} else {
		var contains = '';
		var all_data_name = '';
		$("li.filter_name_li.active input.tag_name_hidden").each(function() {
			var get_name = $(this).attr('data-name');
			var get_all_tag = $(this).val();
			console.log(get_all_tag);
			var cross_button = $(".cross_button_for_filters").html();
			all_data_name += '<div class="cross_btn_wrapper" >' + get_name + '<span class="individual_cross" data-tag="' + get_all_tag + '">' + cross_button + '</span>' + '</div>';
			contains += get_all_tag + '+';
		});
		var get_name = all_data_name.slice(0, -1);
		var final_contains = contains.slice(0, -1);
		var get_col = $("#get_current_url").attr('data-col-url');
		var url = get_col + "/" + final_contains;
		console.log("get_name===" + get_name);
		console.log("final_contains===" + final_contains);
		console.log("get_col===" + get_col);
		console.log("url===" + url);
	}
	$("span.clear_all_text").show();
	$("#get_current_url").val(url);
	var all_actives = $('li.filter_name_li.active').length;
	if (all_actives > 0) {
		$(".clear_all_text").addClass('active');
	} else {
		$(".clear_all_text").removeClass('active');
	}
	console.log(url);
	$.ajax({
		url: url,
		type: "GET",
		dataType: "html",
        beforeSend:function(){
            $('.shop-page-content').html('<div class="loader-gif"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0645/2772/8893/files/Spinner.gif?v=1670568714"></div>');
        },
		success: function(data) {
            if(all_actives > 0 ){
              $(".clear_all_text").html('Filter by: ');
            }else{
              $(".clear_all_text").html('');
            }
			console.log(url);
            window.history.replaceState({ }, '', url);      
			var found = $(data).find("div").hasClass("Collection-notFound");
			$('.shop-page-content').html($(data).find('.shop-page-content').html());
          
            if($('.grid-icon-2').hasClass('active')){
              $('#product-grid').removeClass('grid--3-col-desktop');
              $('#product-grid').addClass('grid--2-col-desktop');
            }else{
              $('#product-grid').removeClass('grid--2-col-desktop');
              $('#product-grid').addClass('grid--3-col-desktop');        
            }
          
			$(".selected_filters").removeClass('hide');
			$(".selected_filters span.filters_names").html(get_name);
		},
	});
});

// Selected filters cross button
$(document).on('click', '.individual_cross', function(e) {
	var remove_url = $(this).attr('data-tag');
	var data_val = $("#get_current_url").val();
	console.log(data_val);
	console.log(remove_url);
	$(this).parent().addClass('hide');
	$("li.filter_name_li.active").each(function() {
		var equal = $(this).find('.tag_name_hidden').val();
		if (equal == remove_url) {
			console.log('1' + equal);
			console.log('2' + remove_url);
			$(this).removeClass('active');
		}
	});
	if (data_val.indexOf(remove_url) != -1) {
		data_val = data_val.replace(remove_url, "");
	}
	var plus_yes = data_val.slice(-1);
	if (plus_yes == '+') {
		data_val = data_val.slice(0, -1) + '';
		$("#get_current_url").val(data_val);
	} else {
		$("#get_current_url").val(data_val);
	}
	var data_val2 = $("#get_current_url").val();
    window.history.replaceState({ }, '', data_val2);      
	$.ajax({
		url: data_val2,
		type: "GET",
		dataType: "html",
		beforeSend:function(){
            $('.shop-page-content').html('<div class="loader-gif"><img loading="lazy" src="https://cdn.shopify.com/s/files/1/0645/2772/8893/files/Spinner.gif?v=1670568714"></div>');
        },
		success: function(data) {
			$('.shop-page-content').html($(data).find('.shop-page-content').html());
          if($('.grid-icon-2').hasClass('active')){
              $('#product-grid').removeClass('grid--3-col-desktop');
              $('#product-grid').addClass('grid--2-col-desktop');
            }else{
              $('#product-grid').removeClass('grid--2-col-desktop');
              $('#product-grid').addClass('grid--3-col-desktop');        
            }
			$(".selected_filters").removeClass('hide');
			$(".selected_filters span.filters_names").html(get_name);
		},
	});
	var chkClass = $('.cst_' + remove_url);
	if (chkClass.hasClass('active')) {} else {
		console.log('hello1');
	}
	var a = $(".cross_btn_wrapper.hide").length;
	var b = $(".cross_btn_wrapper").length;
	if (a == b) {
		$("span.clear_all_text").hide();
	} else {
		$("span.clear_all_text").show();
	}
});

function ScrollExecute() {
  if (!isActive && $(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
    isActive = true;
    let scrollNode = $('.main-loadmore').last();
    let nextUrl = $(scrollNode).find('a').attr("href");
    if (scrollNode.length > 0 && scrollNode.css('display') != 'none') {
      $.ajax({
        type: 'GET',
        url: nextUrl,
        beforeSend: function () {
          $('.loadmore-btn').html('Loading');
        },
        success: function (data) {
          scrollNode.remove();
          var page2data = $(data).find('#product-grid').html();
          $('#product-grid').append(page2data);
          isActive = false;
        },
        dataType: "html"
      });
    }
  }
}

var isActive = false;

$(document).ready(function () {
  $(window).scroll(function () {
    setTimeout(function () {
      ScrollExecute();
    }, 1200);
  });
});